import { get, isFunction, toString } from 'lodash/fp';
import classnames from 'classnames/bind';
import type { TableColumn } from './types';
import * as styles from './Table.css';

const cx = classnames.bind(styles);

export interface DataCellProps<TRow> {
    column: TableColumn<TRow>;
    row: TRow;
}

export function DataCell<TRow>({ row, column }: DataCellProps<TRow>) {
    const { field, elide, style, renderer } = column;
    const value = get(field, row);
    const classes = cx('cell', { elide });

    return (
        <td className={classes} style={style} title={elide ? toString(value) : undefined}>
            {isFunction(renderer) ? renderer(value, row) : toString(value)}
        </td>
    );
}
